module.exports = __webpack_public_path__ + "static/media/deleteBucket.37779a79.svg";